import {INITIALISE_STATE, UPDATE_PDF} from '../actions/types';

const initialState = {
    currentPdf: null,
}

export default function document(state = initialState, action){
    switch (action.type) {
        case INITIALISE_STATE:
            if (!action.payload) return state;
            return Object.assign({}, state, action.payload)
            case UPDATE_PDF: {
                return { ...state, currentPdf: action.payload }
            }

        default:
            return state;
    }
}